import api from 'api';

export const loadCategories = api('GET /api/influencers-categories/list');

export const loadCategory = api('GET /api/influencers-categories/:id');

export const createCategory = api('POST /api/influencers-categories');

export const updateCategory = api('PUT /api/influencers-categories/:id');

export const deleteCategory = api(
  'POST /api/influencers-categories/:id/delete'
);

export const exportCategories = api('GET /api/influencers-categories/export', {
  responseType: 'blob',
});
export const uploadCategories = api(`POST /api/influencers-categories/upload`);

export const checkUploadCategories = api(
  'GET /api/influencers-categories/upload/:jobId/status'
);
